import {
    Button,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {Link as RouterLink} from 'react-router-dom';
import {Can} from '../../../components/Can';
import {Role} from '../../../graphql/auth';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    roles: Role[],
}) => {
    const {className, roles, ...rest} = props;
    const classes = useStyles();

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title="All roles"
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Active</TableCell>
                                        <TableCell>User Count</TableCell>
                                        <TableCell align="right">Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {roles.map(role => (
                                        <TableRow hover key={role.id}>
                                            <TableCell>{role.name}</TableCell>
                                            <TableCell>{role.description}</TableCell>
                                            <TableCell>{role.active ? 'active' : 'inactive'}</TableCell>
                                            <TableCell>{role.users!.length}</TableCell>
                                            <TableCell align="right">
                                                <Can checkAll permission="role_higher_level" data={{role}}>
                                                    <Button
                                                        color="primary"
                                                        component={RouterLink}
                                                        size="small"
                                                        to={`/roles/${role.id}`}
                                                        variant="outlined"
                                                    >
                                                        View
                                                    </Button>
                                                </Can>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
            </Card>
        </div>
    );
};

export default Results;
